import { render } from "./HeaderComponet.vue?vue&type=template&id=367c03e4&scoped=true&ts=true"
import script from "./HeaderComponet.vue?vue&type=script&lang=ts"
export * from "./HeaderComponet.vue?vue&type=script&lang=ts"

import "./HeaderComponet.vue?vue&type=style&index=0&id=367c03e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367c03e4"]])

export default __exports__